import { Div, Link } from "@tblabs/truffle";


export class OptionsBox extends Div
{
    constructor(menu: Record<string, () => void>)
    {
        super();
        this.TextAlignCenter().MarginTop(16)

        this.Append(
            ...Object.entries(menu)
                .map(([label, action]) => new Link(label).MarginLeft(16).Style("white-space: nowrap")
                    .OnClick(action)
                )
        );
    }
}
